import { useContext } from 'react';
import { CreateStockTransfersContext, CreateStockTransfersValues } from '../contexts/CreateStockTransfersContext';
import { DialogTitle } from '@mui/material';
import { CloseDialogAction } from '../../../../../components/shared/dialogs/CloseDialogAction';

export const CreateStockTransfersHeader = () => {
  const { onCancel, isSubmittedSuccess, successDismissButtonHandler, t } = useContext(CreateStockTransfersContext) as CreateStockTransfersValues;

  return (
    <DialogTitle>
      {t('create_modal.title')}
      <CloseDialogAction onCancel={() => {
        onCancel(isSubmittedSuccess);
        successDismissButtonHandler();
      }} />
    </DialogTitle>
  );
};

